const ANIM_BASE_CLASS = 'anim-element'
const ANIMATIONS_CONFIG = [
    {
        block: '.fd-block-onglets-vertical-avec-visuel',
        elements: [
            {
                selector: '.heading',
                animationClasses: 'translate-y'
            },
            {
                selector: '.tabs-wrapper',
                animationClasses: 'translate-y'
            },
            {
                selector: '.visuals-wrapper',
                animationClasses: 'translate-x'
            }
        ]
    },
    {
        block: '.wp-block-contenus3-colonnes',
        elements: [
            {
                selector: '.heading',
                animationClasses: 'translate-y'
            },
            {
                selector: '.columns',
                animationClasses: 'translate-y'
            },
            {
                selector: '.cta-wrapper',
                animationClasses: 'translate-y'
            }
        ]
    },
    {
        block: '.image-et-contenus-en-colonnes',
        elements: [
            {
                selector: '.text-content',
                animationClasses: 'translate-y'
            },
            {
                selector: '.image-content',
                animationClasses: 'translate-x'
            }
        ]
    },
    {
        block: '.fd-block-ctas-encadres',
        elements: [
            {
                selector: '.ctas-container > .card-cta',
                animationClasses: 'translate-y'
            }
        ]
    },
    {
        block: '.fd-block-contacts-emails',
        elements: [
            {
                selector: '.text-content',
                animationClasses: 'translate-y'
            },
            {
                selector: '.contacts-content',
                animationClasses: 'translate-x'
            }
        ]
    },
    {
        block: '.archives-singles.articles',
        elements: [
            {
                selector: 'article.archives-singles-card-row',
                animationClasses: 'translate-y'
            }
        ]
    }
]

/**
 * add class appear on element with data-appear-anim
 *
 * @param {HTMLElement} $el HTML Element
 */
class AppearAnim {
    $element: Element

    constructor($element: Element, elementClassToObserve: string) {
        this.$element = $element
        this.onIntersection = this.onIntersection.bind(this)
        const observer = new IntersectionObserver(this.onIntersection)
        const elementToObserve = elementClassToObserve ? $element.querySelector(`${elementClassToObserve}`) : null

        observer.observe(elementToObserve || this.$element)
    }

    /**
     * @param {IntersectionObserverEntry[]} entries
     */
    onIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.$element.classList.add('appear')
            }
        })
    }
}

function detectBlocksWithAnimation() {
    ANIMATIONS_CONFIG.forEach(conf => {
        const blocksWithAnim = document.querySelectorAll(conf.block)
        console.log('blocksWithAnim: ', blocksWithAnim)
        blocksWithAnim.forEach(blockEl => {
            for (const elAnim of conf.elements) {
                const targetEls = blockEl.querySelectorAll(elAnim.selector)

                targetEls.forEach(t => {
                    t.classList.add(ANIM_BASE_CLASS)
                    t.classList.add(elAnim.animationClasses)
                })
            }
        })
    })
}

function initializeObservation() {
    const $appearAnimElements = document.querySelectorAll(`.${ANIM_BASE_CLASS}`)
    $appearAnimElements.forEach($element => {
        // Check if there is an element inside to observe
        const elementClassToObserve = Array.from($element.classList).reduce((accu, cssClass) => {
            if (cssClass.startsWith('o-')) {
                return `.${cssClass.substring(2)}`
            }

            return accu
        }, '')

        new AppearAnim($element, elementClassToObserve)
    })
}

export default function initAppearAnim() {
    detectBlocksWithAnimation()
    initializeObservation()
}
